import { defineComponent as _defineComponent } from 'vue'
import { ITableHeader } from "@/utils";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";
import SvgArrow from "@/assets/icons/arrow.svg";
import { computed } from "vue";

interface Props {
    header: ITableHeader
    current: string;
    direction: 'asc' | 'desc' | '';
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SortableHead',
  props: {
    header: null,
    current: null,
    direction: null
  },
  emits: ['change-sort'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
    header: ITableHeader
    current: string;
    direction: 'asc' | 'desc' | '';
}




const isCurrent = computed(() => props.current === props.header.value && props.direction !== '');
const isAsc = computed(() => props.direction === 'asc' && isCurrent.value);


return { __sfc: true,props, emits, isCurrent, isAsc, BaseTooltip, SvgArrow }
}

})